import Warning from '../component/warning';
import { connect } from 'react-redux';
import { getWarning } from '../selector';

const mapStateToProps = state => ({
  warning: getWarning(state)
});

export default connect(mapStateToProps)(Warning);
